var _rect, _circle, _path, _rect2, _path2, _path3, _circle2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle3, _circle4, _circle5, _circle6, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#e9b949"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "#f1cb6c",
    opacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 124C16 100 36 92 60 92S104 100 104 124Z",
    fill: "#4d5d6e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 76,
    width: 20,
    height: 18,
    rx: 3,
    fill: "#6f8599"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52 98H68M52 104H68",
    stroke: "#e9b949",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 30V16",
    stroke: "#6f8599",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 13,
    r: 5,
    fill: "#e8564a"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 46,
    width: 8,
    height: 18,
    rx: 3,
    fill: "#6f8599"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 46,
    width: 8,
    height: 18,
    rx: 3,
    fill: "#6f8599"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 30,
    width: 48,
    height: 48,
    rx: 12,
    fill: "#9db2c4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 34,
    width: 40,
    height: 6,
    rx: 3,
    fill: "#c8d6e2",
    opacity: 0.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 45,
    width: 36,
    height: 16,
    rx: 8,
    fill: "#1d2833"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 53,
    r: 4.6,
    fill: "#7fe3d0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 53,
    r: 4.6,
    fill: "#7fe3d0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 52,
    r: 1.4,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 52,
    r: 1.4,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48 68H72",
    stroke: "#1d2833",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52 68V72M58 68V72M64 68V72M70 68V72",
    stroke: "#1d2833",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait19);
export default __webpack_public_path__ + "static/media/player-portrait-19.6c185c45a154c12977ca999b5e00627c.svg";
export { ForwardRef as ReactComponent };